import React, { useState, useEffect } from "react";

import "./DadosCadastrais.css";

import { ClientePageShell } from "../../../components/ClientePageShell";
import { ModalAlterarDadosCadastrais } from "../../../components/modais/ModalAlterarDadosCadastrais";
import { ModalNovaFormaDePagamento } from "../../../components/modais/ModalNovaFormaDePagamento";
import { DadosBancarios } from "../../../components/DadosBancarios";
import { DadosClientePF } from "../../../components/DadosClientePF";
import { DadosClientePJ } from "../../../components/DadosClientePJ";

import { obterPerfilUsuario, obterTipoUsuario } from '../../../services/cookies'

import AnimateHeight from "react-animate-height";
import { FiChevronDown, FiChevronUp, FiCreditCard, FiUserCheck } from "react-icons/fi";

const DadosCadastrais = () => {
  const [modalAlterar, setModalAlterar] = useState<boolean>(false);
  const [modalNovaFormaDePagamento, setModalNovaFormaDePagamento] =
    useState<boolean>(false);
  const [dadosCadastraisAberto, setDadosCadastraisAberto] = useState(false);

  const [reloadDadosCadastrais, setReloadDadosCadastrais] = useState<boolean>(false)
  const [perfil, setPerfil] = useState<string>('')
  const [reload, setReload] = useState<boolean>(false)

  const [tipoUsuario, setTipoUsuario] = useState<string>('')

  useEffect(() => {
    setPerfil(obterPerfilUsuario())
  }, [])

  useEffect(() => {
    setTipoUsuario(obterTipoUsuario())
  }, [])


  return (
    <>
      <ClientePageShell
        className="dados-cadastrais-page"
        eyebrow="Conta"
        title="Meus Dados"
        subtitle="Consulte seus dados cadastrais e gerencie as informações bancárias vinculadas à sua conta Omex."
      >
        <section className="cliente-page-panel dados-cadastrais-panel">
          <button
            className="dados-cadastrais-toggle"
            type="button"
            aria-expanded={dadosCadastraisAberto}
            onClick={() => setDadosCadastraisAberto(!dadosCadastraisAberto)}
          >
            <span>
              <FiUserCheck />
              <strong>Dados cadastrais</strong>
            </span>
            {dadosCadastraisAberto ? <FiChevronUp /> : <FiChevronDown />}
          </button>

          <AnimateHeight duration={360} height={dadosCadastraisAberto ? 'auto' : 0}>
            <div className="dados-cadastrais-content">
              {tipoUsuario === "Fisica" ? (
                <DadosClientePF
                  reload={reloadDadosCadastrais}
                  setReload={setReloadDadosCadastrais}
                  dadosCadastraisAberto={dadosCadastraisAberto}
                  setDadosCadastraisAberto={setDadosCadastraisAberto}
                  setModalAlterar={setModalAlterar}
                />
              ) : tipoUsuario ? (
                <DadosClientePJ
                  setModalAlterar={setModalAlterar}
                  dadosCadastraisAberto={dadosCadastraisAberto}
                />
              ) : (
                <div className="cliente-page-loading">Carregando dados cadastrais...</div>
              )}
            </div>
          </AnimateHeight>
        </section>

        {(perfil === "UsuarioAssessoria" || perfil === "UsuarioCustodia") && (
          <section className="cliente-page-panel dados-cadastrais-bank-panel">
            <div className="cliente-page-section-header">
              <div>
                <p>Financeiro</p>
                <h2>Dados bancários</h2>
              </div>
              <FiCreditCard />
            </div>
            <DadosBancarios
              handleReload={() => setReload(!reload)}
              reload={reload}
              setModalNovaFormaDePagamento={setModalNovaFormaDePagamento}
            />
          </section>
        )}
      </ClientePageShell>

        {modalAlterar &&
          <ModalAlterarDadosCadastrais
            modal={modalAlterar}
            setModal={setModalAlterar}
            reload={() => setReloadDadosCadastrais(!reloadDadosCadastrais)}
          />
        }
        {modalNovaFormaDePagamento &&
          <ModalNovaFormaDePagamento
            modal={modalNovaFormaDePagamento}
            setModal={setModalNovaFormaDePagamento}
            handleReload={() => setReload(!reload)}
          />
        }
    </>
  );
};

export default DadosCadastrais;
